<template>
  <div  class="cookies" id="radiadoresCookies">
    <div v-if="showCookiesWarning" class="cookies__container">
      <table width="100%">
        <tbody>
          <tr>
            <td align="left"></td>
            <td colspan="2" style="text-align: center">
              <div class="cookies__message--container">
                <p>
                  {{$t('cookie_text')}}
                  <routerLink
                    to="/legales/politica-de-cookies"
                    class="cookies__message--container-text"
                    title="cookies"
                  >{{$t('cookies_policy')}}</routerLink>
                  <span class="cookies__accept-container">
                    <a
                      class="cookies__accept-buton btn btn-link"
                      border="0"
                      @click="handleDontAcceptCookies"
                    >{{$t('cookie_text_dont_accept_button')}}</a>
                  </span>
                  <span class="cookies__accept-container">
                    <a
                      class="cookies__accept-buton btn btn-link"
                      border="0"
                      @click="handleAcceptCookies"
                    >{{$t('accept_label')}}</a>
                  </span>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Cookie',
  data: () => ({
    showCookiesWarning: !Vue.cookies.get('rc-cookies-disabled')
  }),
  methods: {
    handleAcceptCookies () {
      this.$cookies.set('rc-cookies-disabled', 'false')
      location.reload()
    },
    handleDontAcceptCookies () {
      this.$cookies.set('rc-cookies-disabled', 'true')
      this.$forceUpdate()
      this.showCookiesWarning = false
    }
  }
}
</script>

<style lang='less' scoped>
.cookies {
  width: 100%;
  z-index: 99;
  bottom: 0px;
  position: absolute;
  font-size: 1em;
  line-height: 28px;
  height: auto;

  & table {
    margin-bottom: 0;
  }

  &__container {
    width: 100%;
    background-color: #38477F;
    color: #fff;
    opacity: 1;
    height: 100%;
  }

  &__message--container {
    padding: 6px 10px 0 15px;
    & p {
      vertical-align: middle;
    }
  }

  &__message--container-text {
    color: rgb(240, 236, 32);
  }
  &__accept-container {
    margin-left: 0.6em;
  }
  &__accept-buton {
    border-radius: 5px;
    margin-left: 1%;
  }
}

.btn {
    display: inline-block;
    text-align: center;
    text-decoration: none;
    margin: 2px 0;
    border: solid 1px transparent;
    border-radius: 4px;
    padding: 0.2em 0.5em;
    color: #000;
    background-color: #fff;
    cursor: pointer;
}

@media only screen and ( max-width: 668px ) {

  .cookies {
    width: 100%;
    font-size: 1em;
    line-height: 30px;
    bottom: 0;
    right: 0;
  }

}
</style>
